import React, { useState, useEffect } from "react";
import "./CardTabs.scss";
import CreditCard from "../../images/platacard.png";
import Mastercard from "../../images/revemastercard.png";
import Defaultcard from "../../images/default-dark.png";
import { useSelector } from "react-redux";
import {
  assignPhysicalCard,
  assignExternalCard,
} from "../../util/API/cardservices";
import BaseButton from "../UI/BaseButton/BaseButton";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import PinPad from "../PinPad/PinPad";
import {
  Box,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import BaseCard from "../UI/BaseCard/BaseCard";
import { getCustomerAccount, getMastercardDetails } from "../../util/API/transfer";

function AddNewCardModal({ open, handleClose, cards, mastercards }) {
  //test card 45532111111112222260
  const [newCardNum, setNewCardNum] = useState("");
  const [selectedProgram, setSelectedProgram] = useState("program");
  const [disableSave, setDisableSave] = useState(false);
  const [cardName, setCardName] = useState("");
  const [feeExempt, setFeeExempt] = useState("-1");
  const [cardPurpose, setCardPurpose] = useState("0");
  const [showPinPad, setShowPinPad] = useState(false);
  const [alert, setAlert] = useState({
    showAlert: false,
    message: "",
    severity: "",
    header: "",
  });
  const [transactionInformation, setTransactionInformation] = useState([]);
  const [loading, setLoading] = useState(false); 
  let isOperator = sessionStorage.getItem("isOperator");

  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;
  const parentuserid = sessionStorage.getItem("parentuserid");

  const currentUser = useSelector((state) => state.usersList.selectedUser);
  // console.log(currentUser)

  // console.log(cards, mastercards)

  const isMCActive = async (row) => {
    try {
      const response = await getMastercardDetails(
        row.Vuserpi3.id,
        currentUser.User.id,
        row.Vuserpi3.currcode
      );
      if(response.payload?.forConsumer?.data?.cardStatusId === "4") {
        return true
      }
      else {
        return false
      }
    } catch (error) {
      console.error("Error fetching card status:", error);
    }
  };

  const getAccounts = async () => {
    const response = await getCustomerAccount(currentUser.User.id);
    // console.log("getAccounts_response-----------",response);

    let recordsArr = response?.ServiceData?.record;
    if (!Array.isArray(recordsArr)) {
      recordsArr = [recordsArr];
    }

    const records = recordsArr?.filter(
      (record) => record?.Vtransfersourcepis?.piid === "229"
    );

    // Filter out duplicates based on unique identifiers (e.g., account ID)
    const uniqueRecords = records?.filter(
      (record, index, self) =>
        index === self.findIndex(
          (r) => r?.Vtransfersourcepis?.acctID === record?.Vtransfersourcepis?.acctID
        )
    );

    setTransactionInformation(uniqueRecords);
  };

  useEffect(() => {
    getAccounts();
    setCardName(currentUser.User.firstName + " " + currentUser.User.lastName);
    setNewCardNum("");
    setSelectedProgram("program");
  }, []);

  useEffect(() => {
    setCardName(currentUser.User.firstName + " " + currentUser.User.lastName);
    setNewCardNum("");
    setSelectedProgram("program");
  }, [open]);

  // console.log(transactionInformation)

  const handleCardNameChange = (event) => {
    setCardName(event.target.value);
  };

  const handleConfirm = (event, pin) => {
    let PIN = pin.join("");
    addNewCard(PIN);
  };

  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);

  const addNewCard = async (pin) => {
    let response = null;

    setLoading(true)

    if (currentUser.User.profilestatus !== "4") {
      setAlert({
        header: "Error",
        message: "Please complete our KYC process (IDs and Selfie) before completing this transaction. Thank you.",
        severity: "error",
        showAlert: true,
      });
      setShowPinPad(false);
      return;
    }

    if (selectedProgram === "plata") {
      response = await assignPhysicalCard(
        newCardNum,
        currentUser.User.id,
        transactionInformation[0]["Vtransfersourcepis"].id,
        pin,
        agent["User"].id, // agent
        currentUser.User.firstName,
        currentUser.User.lastName,
        currentUser.Useremailaccount.emailAccount
      );
    } else if (selectedProgram === "mc") {
      // for (const card of mastercards) {
      //   const isActive = await isMCActive(card);
      //   if (isActive) {
      //     setAlert({
      //       header: "Error",
      //       message:
      //         "MC Assigning failed. You can only have one MC active at a time.",
      //       severity: "error",
      //       showAlert: true,
      //     });
      //     setLoading(false);
      //     setShowPinPad(false);
      //     return;
      //   }
      // }

      response = await assignExternalCard(
        newCardNum,
        currentUser.User.id,
        313,
        cardName,
        cardPurpose,
        feeExempt,
        currentUser.Useremailaccount.emailAccount,
        pin,
        agent["User"].id, // agent
        agent["User"].firstName, // agent
        agent["User"].lastName, // agent
        parentuserid,
        isOperator
      );
    }

    if (response?.extstatus === "1" || response?.callStatus === "1") {
      setAlert({
        header: "Congratulations",
        message: "Card updated successfully",
        severity: "success",
        showAlert: true,
      });

      if (pinConfiguration === "once") {
        sessionStorage.setItem("pin", pin);
      }
    } else {
      setAlert({
        header: "Error",
        message: "Failed to update card." + response?.payload?.msg,
        severity: "error",
        showAlert: true,
      });
    }
    setLoading(false)
    setShowPinPad(false);
    return response;
  };

  const setNewCardNumber = (event) => {
    setNewCardNum(event.target.value);
  };
  const handleProgramChange = (event) => {
    // console.log(event)
    setSelectedProgram(event.target.value);
  };
  const handleCardPurpose = (event) => {
    setCardPurpose(event.target.value);
  };
  const handleFeeExempt = (event) => {
    setFeeExempt(event.target.value);
  };

  let pin = sessionStorage.getItem("pin");

  const handleSaveClick = async () => {
    if (selectedProgram === "mc") {
      // for (const card of mastercards) {
      //   const isActive = await isMCActive(card);
      //   if (isActive) {
      //     setAlert({
      //       header: "Error",
      //       message: "MC Assigning failed. You can only have one MC active at a time.",
      //       severity: "error",
      //       showAlert: true,
      //     });
      //     setLoading(false);
      //     setShowPinPad(false);
      //     return;
      //   }
      // }
    }

    else if (selectedProgram === "plata") {
      if (Array.isArray(cards)) {
        for (const card of cards) {
          if (card.globaluserextref?.active === "1") {
            setAlert({
              header: "Error",
              message: "Platacard assigning failed. You can only have one active Platacard at a time.",
              severity: "error",
              showAlert: true,
            });
            setLoading(false);
            setShowPinPad(false);
            return;
          }
        }
      }
    }
  
    // Proceed with adding a new card
    if (pin) {
      addNewCard(pin);
    } else if (pinConfiguration === "never") {
      addNewCard("0000");
    } else {
      setShowPinPad(true);
    }
  };

  return (
    <>
      <BaseDrawer
        open={open}
        handleClose={handleClose}
        height="80vh"
        title={"Create New Card"}
        overflow={"auto"}
      >
        <BaseCard>

          <Box className="cardtabs-container">
            <Box className="card-container-side">
              <Box className="creditcard-container">
                <img src={selectedProgram === "mc" ? Mastercard : selectedProgram === "plata" ?  CreditCard : Defaultcard} className="credit-card-img" loading="lazy" />
              </Box>
              <Box />
            </Box>
            <Box className="cards-second-half">
              <Box className="card-program-container">
                <Select
                  name="card-options"
                  id="card-program"
                  onChange={handleProgramChange}
                  value={selectedProgram}
                  className="card-inputs card-inputs-text"
                  required
                  sx={{
                    border: "1px solid #D7D7D7",
                    height: "35px",
                    borderRadius: "5px",
                    minWidth: "200px",
                  }}
                >
                  <MenuItem value="program">Card Program</MenuItem>
                  <MenuItem value="plata">Rêve Plata Card</MenuItem>
                  <MenuItem value="mc">Rêve Mastercard</MenuItem>
                </Select>
              </Box>
              <Box className="usd-vcc-container">
                <Box>
                  <Select
                    name="card-options"
                    id="card-program"
                    disabled={true}
                    className="card-inputs"
                    value={"0"}
                    sx={{
                      border: "1px solid #D7D7D7",
                      height: "35px",
                      borderRadius: "5px",
                      minWidth: "200px",
                    }}
                  >
                    <MenuItem value="0">USD</MenuItem>
                  </Select>
                </Box>
                <Box>
                  <TextField
                    placeholder="Card Number"
                    value={newCardNum}
                    onChange={setNewCardNumber}
                    sx={{
                      "& .MuiInputBase-root": {
                        maxHeight: "35px",
                        fontSize: "14px",
                        border: "1px solid #D7D7D7",
                      },
                      minWidth: "200px",
                      padding: "8px 0px",
                      margin: "8px 0",
                    }}
                  />
                </Box>
                {selectedProgram === "mc" && (
                  <>
                    <Box>
                      <TextField
                        placeholder="Card Name"
                        value={cardName}
                        onChange={handleCardNameChange}
                        sx={{
                          "& .MuiInputBase-root": {
                            maxHeight: "35px",
                            fontSize: "14px",
                            border: "1px solid #D7D7D7",
                          },
                          minWidth: "200px",
                          padding: "8px 0px",
                          margin: "8px 0",
                        }}
                      />
                    </Box>
                    <Box>
                      <Select
                        name="card-options"
                        id="card-purpose"
                        disabled={false}
                        onChange={handleCardPurpose}
                        value={cardPurpose}
                        className="card-inputs"
                        placeholder="Purpose of Account"
                        sx={{
                          border: "1px solid #D7D7D7",
                          height: "35px",
                          borderRadius: "5px",
                          minWidth: "200px",
                          margin: "8px 0",
                        }}
                      >
                        <MenuItem value="0">Purpose of Account</MenuItem>
                        <MenuItem value="1">Remittance Transactions</MenuItem>
                        <MenuItem value="2">Digital Wallet and Payroll</MenuItem>
                        <MenuItem value="3">Mastercard</MenuItem>
                      </Select>
                    </Box>
                    <Box>
                      <Select
                        name="card-options"
                        id="fee-exempt"
                        disabled={false}
                        onChange={handleFeeExempt}
                        className="card-inputs"
                        placeholder="Fee exemption"
                        value={feeExempt}
                        sx={{
                          border: "1px solid #D7D7D7",
                          height: "35px",
                          borderRadius: "5px",
                          minWidth: "200px",
                          margin: "8px 0",
                        }}
                      >
                        <MenuItem value="-1">Fee exemption</MenuItem>
                        <MenuItem value="0">No</MenuItem>
                        <MenuItem value="1">Yes</MenuItem>
                      </Select>
                    </Box>
                  </>
                )}
              </Box>
              <BaseButton
                buttonText={"Save"}
                onClick={(event) => {handleSaveClick()}}
                disabled={disableSave}
                buttonStyle={"add-new-button"}
              />
            </Box>
          </Box>
          <CustomAlert
            severity={alert.severity}
            show={alert.showAlert}
            header={alert.header}
            message={alert.message}
            onClick={() => {
              setAlert((prevDetails) => ({ ...prevDetails, showAlert: false }));
              if (alert.severity === "success") {
                handleClose();
              }
            }}
            autoclose={alert.severity === "error" ? false : true}
          />
          {showPinPad && (
            <PinPad
              show={showPinPad}
              handleConfirm={handleConfirm}
              onClick={() => setShowPinPad(false)}
              loading={loading}
            />
          )}
        </BaseCard>
      </BaseDrawer>
    </>
  );
}

export default AddNewCardModal;
